import React from 'react'
import clsx from 'classnames'
import styles from './Arrow.module.scss'

export type ArrowDirection = 'left' | 'right' | 'up' | 'down'

type ArrowProps = React.HTMLAttributes<HTMLSpanElement> & {
  direction?: ArrowDirection,
  bigOne?: boolean,
  isDark?: boolean,
  isSmall?: boolean,
}

export const Arrow: React.FC<ArrowProps> = (props) => {
  // isDark and isSmall are accepted for old call sites but have no styles
  const { onClick, direction, className, bigOne, isDark: _isDark, isSmall: _isSmall, ...rest } = props
  return (
    <span
      onClick={onClick}
      data-direction={direction}
      className={clsx([styles.container, className, { [styles.isBig]: bigOne }])}
      {...rest}
    >
      <i className={styles.arrow} />
    </span>
  )
}
